import { getYaxisConfig } from "../utils/utils";
import { BUSINESS_UNIT } from "../../../utils/PreviousSession.constants";
const SOURCE = {
  SOURCE_1: "1",
  SOURCE_2: "2",
};

const REGIONS = {
  EMEA: "EMEA",
  SA: "SA",
  NA: "NA",
  SA_PG: "SA (PG)",
  SA_ES: "SA (ES)",
  NA_MX_ES: "North America (MX,SP)",
};

export const REGION_LABELS = {
  North_America: "North America",
  South_America: "South America",
  South_America_PG: "South America (PG)",
  South_America_ES: "South America (ES)",
  NA_MX_ES: "North America (MX,SP)",
};

const FIELDS = {
  price: "price",
  market: "market",
  volume: "volume",
};

export const COLOR_CODES = {
  A22B2F: "#A22B2F",
  "638C1C": "#638C1C",
};
export const SECTIONS_TITLE = {
  OUTSIDE_MARKET: "Outside Markets",
  PREVIOUS_SESSION: "Previous Session",
  WEATHER: "Weather",
  MARKET_OVERVIEW: "Market Overview",
  EARLY_MARKETS: "Early Markets",
  ADVERTISEMENT: "Advertisement",
  ECONOMIC_INDICATORS: "Economic Indicators",
};

export const GENERATE_IMAGE_BUSINESS_UNITS = {
  [BUSINESS_UNIT.CORN]: [REGIONS.NA],
  [BUSINESS_UNIT.COCOA]: [REGIONS.EMEA, REGIONS.SA_PG, REGIONS.SA_ES, REGIONS.NA],
  [BUSINESS_UNIT.EDIBLE_OILS]: [REGIONS.EMEA, REGIONS.NA, REGIONS.SA, REGIONS.NA_MX_ES],
  [BUSINESS_UNIT.ANIMAL_FEED]: [REGIONS.EMEA],
  [BUSINESS_UNIT.GRAINS]: [REGIONS.EMEA],
};

export const USD_CURRENCY_SYMBOL = "USD";
export const EUR_CURRENCY_SYMBOL = "EUR";
// Early market chart
export const chart_symbols = {
  [BUSINESS_UNIT.EDIBLE_OILS]: {
    [REGIONS.EMEA]: [
      {
        unit: "month",
        unitValue: 6,
        axis: [
          getYaxisConfig(
            "right",
            "y-axis-1",
            { display: true, title: "Price per MT", color: "black" },
            { color: "black", weight: "normal", size: 12 },
            false,
            { stepSize: 50 },
            true
          ),
        ],
        symbols: [
          {
            name: "C3:CNO1RDM1",
            currency: USD_CURRENCY_SYMBOL,
            source: "barchart",
            config: {
              label: "CNO CIF R'DAM (USD)",
              yAxisID: "y-axis-1",
              pointStyle: "line",
              borderColor: "red",
            },
          },
          {
            name: "C3:PKO1RDM1",
            currency: USD_CURRENCY_SYMBOL,
            source: "barchart",
            config: {
              label: "PKO CIF R'Dam (USD)",
              yAxisID: "y-axis-1",
              pointStyle: "line",
              borderColor: "brown",
            },
          },
        ],
      },
      {
        unit: "month",
        unitValue: 6,
        axis: [
          getYaxisConfig(
            "right",
            "y-axis-2",
            { display: true, title: "Price per MT", color: "black" },
            { color: "black", weight: "normal", size: 12 },
            false,
            { stepSize: 50 },
            true
          ),
        ],
        symbols: [
          {
            name: "C3:RPO8NLM1",
            source: "barchart",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "RSO FDM (EUR)",
              yAxisID: "y-axis-2",
              pointStyle: "line",
              borderColor: "#007bff",
            },
          },
          {
            name: "C3:SBO8NLM1",
            source: "barchart",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "SBO FDM (USD)",
              yAxisID: "y-axis-2",
              pointStyle: "line",
              borderColor: "#05bffa",
            },
          },

          {
            name: "KN*3",
            source: "barchart",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "BMD CPO USD",
              yAxisID: "y-axis-2",
              pointStyle: "line",
              borderDash: [5, 5],
              borderColor: "#2ca541",
            },
          },
          {
            name: "C3:SFO0WEM1",
            source: "barchart",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "SFO Sixports (USD)",
              yAxisID: "y-axis-2",
              pointStyle: "line",
              borderDash: [5, 5],
              borderColor: "#cccc48",
            },
          },
        ],
      },
      // {
      //   unit: "month",
      //   unitValue: 6,
      //   // axis: [
      //   //   getYaxisConfig(
      //   //     "left",
      //   //     "y-axis-2",
      //   //     { display: true, title: "USD/MT", color: "black" },
      //   //     { color: "black", weight: "normal", size: 12, label: "$" },
      //   //     false,
      //   //     { stepSize: 50 },
      //   //     true
      //   //   ),
      //   // ],
      //   symbols: [

      //   ],
      // },
    ],
    [REGIONS.NA]: [
      {
        unit: "month",
        unitValue: 6,
        axis: [
          getYaxisConfig(
            "right",
            "y-axis-1",
            { display: true, title: "US Cents Per Pound", color: "#0b780c" },
            { color: "#0b780c", weight: "normal", size: 14, label: "" },
            true
          ),
        ],
        symbols: [
          {
            name: "ZL*2",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "CBOT CRUDE SOYABEAN OIL (USD)",
              yAxisID: "y-axis-1",
              pointStyle: "line",
              borderColor: "#0b780c",
            },
          },
        ],
      },
    ],
    [REGIONS.NA_MX_ES]: [
      {
        unit: "month",
        unitValue: 6,
        axis: [
          // Visible right axis for BMD CPO USD
          getYaxisConfig(
            "left",
            "y-axis-1",
            {
              display: true,
              title: "US Cents Per Pound",
              color: "#0b780c",
            },
            {
              color: "#0b780c",
              weight: "normal",
              size: 14,
              label: "",
            },
            true
          ),
          // Hidden left axis for CBOT SOYBEAN OIL (scaling only)
          getYaxisConfig(
            "right",
            "y-axis-2",
            {
              display: true, // hide ticks & title
              title: "Price per MT",
              color: "blue",
              grid: { display: false }, // hide grid lines
            },
            {
              color: "blue",
              weight: "normal",
              size: 14,
              label: "",
            },
            false
          ),
        ],
        symbols: [
          {
            name: "ZL*2",
            source: "barchart",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "CBOT CRUDE SOYABEAN OIL (USD)",
              yAxisID: "y-axis-1", // uses hidden axis for correct scale
              pointStyle: "line",
              borderColor: "#0b780c",
            },
          },
          {
            name: "KN*3",
            source: "barchart",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "BMD CPO USD",
              yAxisID: "y-axis-2", // uses visible right axis
              pointStyle: "line",
              borderColor: "blue",
            },
          },
        ],
      },
    ],
    [REGIONS.SA]: [
      {
        unit: "month",
        unitValue: 6,
        axis: [
          getYaxisConfig(
            "right",
            "y-axis-1",
            { display: true, title: "USD per MT", color: "black" },
            { color: "black", weight: "normal", size: 14, label: "$ " },
            true
          ),
        ],
        symbols: [
          {
            name: "C3:SBO0RDF1",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "Cash Soyoil FOB Paranagua",
              yAxisID: "y-axis-1",
              pointStyle: "line",
              borderColor: "#005e86",
            },
          },
          {
            name: "C3:SFO0WEM1",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "Sunflower Oil FOB Argentina",
              yAxisID: "y-axis-1",
              pointStyle: "line",
              borderColor: "#279989",
            },
          },
          {
            name: "C3:PLR0MYM1",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "RBD Palm Oil FOB Malaysia",
              yAxisID: "y-axis-1",
              pointStyle: "line",
              borderColor: "#abad25",
            },
          },
          {
            name: "C3:PKO1MYM1",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "RBD Palm Kernal Oil FOB Malaysia",
              yAxisID: "y-axis-1",
              pointStyle: "line",
              borderColor: "#3ac552",
            },
          },
        ],
      },
    ],
  },
  [BUSINESS_UNIT.ANIMAL_FEED]: {
    [REGIONS.EMEA]: [
      {
        unit: "days",
        unitValue: "42",
        axis: [
          getYaxisConfig(
            "left",
            "animal-emea-y-axis-left",
            { display: true, title: "USD/ST", color: "black" },
            { color: "black", weight: "normal", size: 12, label: "$" },
            false,
            { stepSize: 5 },
            true
          ),
          getYaxisConfig(
            "right",
            "animal-emea-y-axis-right",
            { display: true, title: "EUR/MT", color: "black" },
            { color: "black", weight: "normal", size: 12, label: "€" },
            false,
            { stepSize: 5 },
            true
          ),
        ],
        symbols: [
          {
            name: "ZMH22",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "CBOT SBM (USD)",
              yAxisID: "animal-emea-y-axis-left",
              pointStyle: "line",
              borderColor: "#005e86",
              borderDash: [5, 5],
            },
          },
          {
            name: "C3:RPM0LRM2",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "RSM LR (EUR)",
              yAxisID: "animal-emea-y-axis-right",
              pointStyle: "line",
              borderColor: "#279989",
            },
          },
          {
            name: "C3:SFM8LOM2",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "SFM HP CIF French Atlantic Bay (EUR)",
              yAxisID: "animal-emea-y-axis-right",
              pointStyle: "line",
              borderColor: "#3ac552",
            },
          },
        ],
      },
    ],
  },
  [BUSINESS_UNIT.GRAINS]: {
    [REGIONS.EMEA]: [
      {
        unit: "month",
        unitValue: 1,
        axis: [
          getYaxisConfig(
            "left",
            "y-axis-1",
            { display: true, title: "USC/BU", color: "black" },
            { color: "black", weight: "normal", size: 12, label: "$ " },
            false
          ),
          getYaxisConfig(
            "right",
            "y-axis-2",
            { display: true, title: "EUR/MT", color: "black" },
            { color: "black", weight: "normal", size: 12, label: "€ " },
            false
          ),
        ],
        symbols: [
          {
            name: "ZC*1",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "Us Corn",
              yAxisID: "y-axis-1",
              pointStyle: "line",
              borderColor: "#005e86",
            },
          },
          {
            name: "ZW*1",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "Us Wheat",
              yAxisID: "y-axis-1",
              pointStyle: "line",
              borderColor: "#279989",
            },
          },
          {
            name: "ML*1",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "European Whilling Wheat",
              yAxisID: "y-axis-2",
              pointStyle: "line",
              borderColor: "#abad25",
            },
          },
          {
            name: "XB*1",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "European Corn",
              yAxisID: "y-axis-2",
              pointStyle: "line",
              borderColor: "#3ac552",
            },
          },
        ],
      },
      {
        unit: "month",
        unitValue: 1,
        axis: [
          getYaxisConfig(
            "right",
            "y-axis-2",
            { display: true, title: "EUR/MT", color: "black" },
            { color: "black", weight: "normal", size: 12, label: "€ " },
            false
          ),
        ],
        symbols: [
          {
            name: "XR*1",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "Rapseed EUR",
              yAxisID: "y-axis-2",
              pointStyle: "line",
              borderColor: "#0b780c",
            },
          },
        ],
      },
    ],
  },
  [BUSINESS_UNIT.COCOA]: {
    [REGIONS.EMEA]: [
      {
        unit: "month",
        unitValue: 6,
        axis: [
          getYaxisConfig(
            "left",
            "y-axis-1",
            { display: true, title: "USD/MT", color: "#a07f5f" },
            { color: "#a07f5f", weight: "normal", size: 12, label: "" },
            false,
            {},
            false
          ),
          getYaxisConfig(
            "right",
            "y-axis-3",
            { display: true, title: "GBP/MT", color: "#638C1C" },
            { color: "#638C1C", weight: "normal", size: 12, label: "" },
            false,
            {},
            false
          ),
        ],
        symbols: [
          {
            name: "CC*1",
            source: "barchart",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "Cocoa New York",
              yAxisID: "y-axis-1",
              borderColor: "#a07f5f",
              pointStyle: "line",
              // borderColor : '#cf6b00',
            },
          },
          {
            name: "CA*1",
            source: "barchart",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "Cocoa London",
              yAxisID: "y-axis-3",
              borderColor: "#638C1C",
              pointStyle: "line",
              // borderColor : '#279989',
            },
          },
        ],
      },
      {
        unit: "month",
        unitValue: 6,
        axis: [
          getYaxisConfig(
            "left",
            "y-axis-2",
            { display: true, title: "Ratio", color: "#bb9200" },
            { color: "#bb9200", weight: "normal", size: 12, label: "" },
            false,
            {},
            false,
            (label) => label.toFixed(2)
          ),
          getYaxisConfig(
            "right",
            "y-axis-4",
            { display: true, title: "Ratio", color: "#cf6b00" },
            { color: "#cf6b00", weight: "normal", size: 12, label: "" },
            false,
            {},
            false,
            (label) => label.toFixed(2)
          ),
        ],
        symbols: [
          {
            name: "CCBUTTER",
            regionId: 2,
            source: "cra",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "Cocoa Butter Ratio",
              yAxisID: "y-axis-2",
              borderColor: "#e5b300",
              pointStyle: "line",
              // borderColor : '#279989',
            },
          },
          {
            name: "CCLIQUOR",
            regionId: 2,
            source: "cra",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "Cocoa Liquor Ratio",
              yAxisID: "y-axis-4",
              borderColor: "#cf6b00",
              pointStyle: "line",
              // borderColor : '#279989',
            },
          },
        ],
      },
    ],
    [REGIONS.SA_PG]: [
      {
        unit: "month",
        unitValue: 6,
        axis: [
          getYaxisConfig(
            "left",
            "cocoa-sa-pg-y-axis-left",
            { display: true, title: "GBP/MT", color: "#638C1C" },
            { color: "#638C1C", weight: "normal", size: 12, label: "" },
            false,
            {},
            false
          ),
          getYaxisConfig(
            "right",
            "cocoa-sa-pg-y-axis-right",
            { display: true, title: "USD/MT", color: "#a07f5f" },
            { color: "#a07f5f", weight: "normal", size: 12, label: "" },
            false,
            {},
            false
          ),
        ],
        symbols: [
          {
            name: "CA*1",
            source: "barchart",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "Cacau Londres",
              yAxisID: "cocoa-sa-pg-y-axis-left",
              borderColor: "#638C1C",
              pointStyle: "line",
            },
          },
          {
            name: "CC*1",
            source: "barchart",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "Cacau Nova Iorque",
              yAxisID: "cocoa-sa-pg-y-axis-right",
              borderColor: "#a07f5f",
              pointStyle: "line",
            },
          },
        ],
      },
      {
        unit: "month",
        unitValue: 6,
        axis: [
          getYaxisConfig(
            "left",
            "y-axis-2",
            { display: true, title: "Ratio", color: "#bb9200" },
            { color: "#bb9200", weight: "normal", size: 12, label: "" },
            false,
            {},
            false,
            (label) => label.toFixed(2)
          ),
          getYaxisConfig(
            "right",
            "y-axis-4",
            { display: true, title: "Ratio", color: "#cf6b00" },
            { color: "#cf6b00", weight: "normal", size: 12, label: "" },
            false,
            {},
            false,
            (label) => label.toFixed(2)
          ),
        ],
        symbols: [
          {
            name: "CCBUTTER",
            regionId: 5,
            source: "cra",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "Cacau Butter Ratio",
              yAxisID: "y-axis-2",
              borderColor: "#e5b300",
              pointStyle: "line",
              // borderColor : '#279989',
            },
          },
          {
            name: "CCLIQUOR",
            regionId: 5,
            source: "cra",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "Cacau Liquor Ratio",
              yAxisID: "y-axis-4",
              borderColor: "#cf6b00",
              pointStyle: "line",
              // borderColor : '#279989',
            },
          },
        ],
      },
    ],
    [REGIONS.SA_ES]: [
      {
        unit: "month",
        unitValue: 6,
        axis: [
          getYaxisConfig(
            "left",
            "cocoa-sa-es-y-axis-left",
            { display: true, title: "GBP/MT", color: "#638C1C" },
            { color: "#638C1C", weight: "normal", size: 12, label: "" },
            false,
            {},
            false
          ),
          getYaxisConfig(
            "right",
            "cocoa-sa-es-y-axis-right",
            { display: true, title: "USD/MT", color: "#a07f5f" },
            { color: "#a07f5f", weight: "normal", size: 12, label: "" },
            false,
            {},
            false
          ),
        ],
        symbols: [
          {
            name: "CA*1",
            source: "barchart",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "Cacao Londres",
              yAxisID: "cocoa-sa-es-y-axis-left",
              borderColor: "#638C1C",
              pointStyle: "line",
            },
          },
          {
            name: "CC*1",
            source: "barchart",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "Cacao Nueva York",
              yAxisID: "cocoa-sa-es-y-axis-right",
              borderColor: "#a07f5f",
              pointStyle: "line",
            },
          },
        ],
      },
      {
        unit: "month",
        unitValue: 6,
        axis: [
          getYaxisConfig(
            "left",
            "y-axis-2",
            { display: true, title: "Ratio", color: "#bb9200" },
            { color: "#bb9200", weight: "normal", size: 12, label: "" },
            false,
            {},
            false,
            (label) => label.toFixed(2)
          ),
          getYaxisConfig(
            "right",
            "y-axis-4",
            { display: true, title: "Ratio", color: "#cf6b00" },
            { color: "#cf6b00", weight: "normal", size: 12, label: "" },
            false,
            {},
            false,
            (label) => label.toFixed(2)
          ),
        ],
        symbols: [
          {
            name: "CCBUTTER",
            regionId: 5,
            source: "cra",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "Cacao Butter Ratio",
              yAxisID: "y-axis-2",
              borderColor: "#e5b300",
              pointStyle: "line",
              // borderColor : '#279989',
            },
          },
          {
            name: "CCLIQUOR",
            regionId: 5,
            source: "cra",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "Cacao Liquor Ratio",
              yAxisID: "y-axis-4",
              borderColor: "#cf6b00",
              pointStyle: "line",
              // borderColor : '#279989',
            },
          },
        ],
      },
    ],
    [REGIONS.NA]: [
      {
        unit: "month",
        unitValue: 6,
        axis: [
          getYaxisConfig(
            "right",
            "cocoa-na-y-axis-right",
            { display: true, title: "USD/MT", color: "#638C1C" },
            { color: "#638C1C", weight: "normal", size: 12, label: "" },
            false,
            {},
            false
          ),
        ],
        symbols: [
          {
            name: "CC*2",
            source: "barchart",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "Cocoa New York",
              yAxisID: "cocoa-na-y-axis-right",
              borderColor: "#638C1C",
              pointStyle: "line",
            },
          },
        ],
      },
      {
        unit: "month",
        unitValue: 6,
        axis: [
          getYaxisConfig(
            "left",
            "y-axis-2",
            { display: true, title: "Ratio", color: "#bb9200" },
            { color: "#bb9200", weight: "normal", size: 12, label: "" },
            false,
            {},
            false,
            (label) => label.toFixed(2)
          ),
          getYaxisConfig(
            "right",
            "y-axis-4",
            { display: true, title: "Ratio", color: "#cf6b00" },
            { color: "#cf6b00", weight: "normal", size: 12, label: "" },
            false,
            {},
            false,
            (label) => label.toFixed(2)
          ),
        ],
        symbols: [
          {
            name: "CCBUTTER",
            regionId: 5,
            source: "cra",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "Cocoa Butter Ratio",
              yAxisID: "y-axis-2",
              borderColor: "#e5b300",
              pointStyle: "line",
              // borderColor : '#279989',
            },
          },
          {
            name: "CCLIQUOR",
            regionId: 5,
            source: "cra",
            currency: EUR_CURRENCY_SYMBOL,
            config: {
              label: "Cocoa Liquor Ratio",
              yAxisID: "y-axis-4",
              borderColor: "#cf6b00",
              pointStyle: "line",
              // borderColor : '#279989',
            },
          },
        ],
      },
    ],
  },
  [BUSINESS_UNIT.CORN]: {
    [REGIONS.NA]: [
      {
        unit: "month",
        unitValue: 6,
        axis: [
          getYaxisConfig(
            "right",
            "y-axis-1",
            { display: true, title: "cents/bu", color: "#0b780c" },
            { color: "#0b780c", weight: "normal", size: 14, label: "" },
            true
          ),
        ],
        symbols: [
          {
            name: "ZC*3",
            currency: USD_CURRENCY_SYMBOL,
            config: {
              label: "Cc3",
              yAxisID: "y-axis-1",
              pointStyle: "line",
              borderColor: "#0b780c",
            },
          },
        ],
      },
    ],
  },
};
// Previous session chart
export const prev_sess_chart_symbols = {
  [BUSINESS_UNIT.EDIBLE_OILS]: {
    [REGIONS.NA]: {
      symbols: [
        "ZS*2",
        "ZM*2",
        "ZC*2",
        "ZW*2",
        "ZL*1",
        "ZL*2",
        "ZL*3",
        "ZL*4",
        "ZL*5",
        "ZL*6",
        "ZL*7",
        "ZL*8",
        "CL*1",
        "RB*1",
        "NG*1",
        "GC*1",
        "DX*1",
      ],
      names: [
        "SOYBEANS",
        "SOY MEAL",
        "CORN",
        "WHEAT",
        "SOYBEAN OIL",
        "SOYBEAN OIL",
        "SOYBEAN OIL",
        "SOYBEAN OIL",
        "SOYBEAN OIL",
        "SOYBEAN OIL",
        "SOYBEAN OIL",
        "SOYBEAN OIL",
        "LIGHT CRUDE",
        "UNLEADED GAS",
        "NATURAL GAS",
        "GOLD",
        "US DOLLAR INDEX",
      ],
      currency: [],
      intervals: [0, 17],
      footer: false,
    },
    [REGIONS.NA_MX_ES]: {
      symbols: [
        "ZL*1",
        "ZL*2",
        "ZL*3",
        "ZL*4",
        "ZL*5",
        "ZL*6",
        "ZL*7",
        "ZL*8",
        "ZS*2",
        "ZM*2",
        "ZC*2",
        "CB*1",
        "DX*1",
        "^USDMXN",
        "RS*2",
      ],
      names: [
        "SOYBEAN OIL",
        "SOYBEAN OIL",
        "SOYBEAN OIL",
        "SOYBEAN OIL",
        "SOYBEAN OIL",
        "SOYBEAN OIL",
        "SOYBEAN OIL",
        "SOYBEAN OIL",
        "SOYBEANS",
        "SOY MEAL",
        "CORN",
        "Brent crude oil",
        "US DOLLAR INDEX",
        "Mexican Peso",
        "ICE Canola",
      ],
      currency: [],
      intervals: [0, 15],
      footer: false,
    },
    [REGIONS.EMEA]: {
      symbols: [
        "KO*3",
        "KN*3",
        "ZL*2",
        "C3:CPO1NLF1",
        "C3:SBO8NLM1",
        "C3:RPO8NLM1",
        "C3:SFO0WEM1",
        "C3:CNO1RDM1",
        "C3:PKO1RDM1",
        "^EURUSD",
        "^MYRUSD",
        "CB*1",
        "LF*1",
        "CF0C0UNL.CS",
        "CF0B0UND.CS",
        "CF090JTK.CS",
      ],
      names: [
        "BMD CPO",
        "BMD CPO",
        "CBOT SBO",
        "CPO CIF R'dam",
        "SBO FDM",
        "RSO FDM",
        "SFO Six Ports",
        "CNO CIF R'dam",
        "PKO CIF R'dam",
        "€/$",
        "$/MYR",
        "Brent crude oil",
        "Gasoil",
        "Soybean Oil",
        "Soymeal",
        "Soybeans",
      ],
      currency: ["MYR", "USD", "USc", "USD", "EUR", "EUR", "USD", "USD", "USD", "USD", "MYR", "USD", "USD"],
      intervals: [0, 3, 9, 13, 16],
      footer: true,
    },
    [REGIONS.SA]: {
      symbols: [
        "ZL*1",
        "C3:SBO0RDF1",
        "C3:SBO0URF1",
        "C3:SFO0WEM1",
        "KO*1",
        "C3:PLR0MYM1",
        "C3:PKO1MYM1",
        "^BRLUSD",
        "CB*1",
        "LF*1",
      ],
      names: [
        "CBOT Soybean Oil",
        "SBO FOB Paranagua",
        "SBO FOB Argy Upriver",
        "Sunflower Oil FOB Argy",
        "BMD Crude Palm Oil",
        "RBD Palm Oil FOB MY",
        "RBD PKO FOB MY",
        "BRL-USD",
        "Brent crude oil",
        "Gasoil",
      ],
      currency: ["Usc", "USD", "USD", "USD", "MYR", "USD", "USD", "BLR", "USD", "USD"],
      intervals: [0, 1, 4, 5, 7, 10],
      footer: false,
    },
  },
  [BUSINESS_UNIT.ANIMAL_FEED]: {
    [REGIONS.EMEA]: {
      symbols: [
        "ZS*2",
        "ZL*2",
        "ZM*2",
        "XR*1",
        "RS*2",
        "C3:RPO8NLM1",
        "C3:RPM0LRM2",
        "C3:SFO0WEM2",
        // "C3:SFM9SZM2",
        "C3:SFM8LOM2",
        // "C3:SFM0UAM1",
        "^EURUSD",
        "^GBPUSD",
        "^USDBRL",
        "^USDARS",
        "CB*1",
        "LF*1",
        "CF0C0UNL.CS",
        "CF0B0UND.CS",
        "CF090JTK.CS",
      ],
      names: [
        "CBOT Sbs",
        "CBOT SBO",
        "CBOT SBM",
        "MATIF Rapseeds",
        "ICE Canola",
        "RSO FDM",
        "RSM LR",
        "SFO 6-ports",
        // "SFM LP CIF FrBay",
        "SFM HP CIF FrBay",
        // "SFM HP FOB Besa",
        "EUR/USD",
        "GBP/USD",
        "$/Real",
        "$/Argy peso",
        "Brent crude oil",
        "Gasoil",
        "Soybean Oil",
        "Soymeal",
        "Soybeans",
      ],
      currency: [
        "USc",
        "USD",
        "USc",
        "EUR",
        "CAD",
        "EUR",
        "EUR",
        "USD",
        // "EUR",
        "EUR",
        // "USD",
        "USD",
        "USD",
        "BRL",
        "ARS",
        "USD",
        "USD",
      ],
      intervals: [0, 5, 9, 15, 18],
      footer: true,
    },
  },
  [BUSINESS_UNIT.GRAINS]: {
    [REGIONS.EMEA]: {
      symbols: [
        "ML*1",
        "XB*1",
        "ZW*1",
        "ZC*1",
        "ZS*1",
        "C3:WHE0MSD1",
        "C3:WHE0CLD1",
        "C3:WHE0DKD1",
        "C3:WHE0LPD1",
        "C3:WHE0RUD1",
        "C3:WHE0CLF1",
        "C3:MAZ0RHD1",
        "C3:MAZ0LPD1",
        "C3:MAZ0BDD1",
        "C3:MAZ0ATF1",
        "^EURUSD",
        "^AUDUSD",
        "^USDRUB",
        "^USDARS",
        "CB*1",
      ],
      names: [
        "Euronext Wheat",
        "Euronext Corn",
        "CBOT Wheat",
        "CBOT Corn",
        "CBOT SBO",
        "Moselle wheat",
        "Creil wheat",
        "Dunkirk wheat",
        "La Pallice wheat ",
        "Rouen wheat",
        "FOB wheat",
        "Rhin corn",
        "La Pallice corn",
        "Bordeaux corn",
        "FOB Maize",
        "EUR/USD",
        "USD/RUB",
        "AUD/USD",
        "$/Argy peso",
        "Brent crude oil",
      ],
      currency: [
        "EUR",
        "EUR",
        "USc",
        "USc",
        "USc",
        "EUR",
        "EUR",
        "EUR",
        "EUR",
        "EUR",
        "EUR",
        "EUR",
        "EUR",
        "EUR",
        "EUR",
        "USD",
        "USD",
        "RUB",
        "ARS",
        "USD",
      ],
      intervals: [0, 5, 15, 20],
      footer: false,
    },
  },
  [BUSINESS_UNIT.COCOA]: {
    [REGIONS.EMEA]: {
      symbols: [
        "CA*1",
        "CC*1",
        "2",
        "2",
        "2",
        "5",
        "5",
        "5",
        "7",
        "7",
        "^EURUSD",
        "^GBPUSD",
        "^AUDUSD",
        "^USDJPY",
        "^USDMYR",
        "^USDIDR",
        "^USDKRW",
        "^USDCNY",
        "CF340UOP.CS",
      ],
      names: [
        "London Futures",
        "NY Futures",
        "Europe CCBUTTER",
        "Europe CCLIQUOR",
        "Europe CCPOWDER",
        "USA CCBUTTER",
        "USA CCLIQUOR",
        "USA CCPOWDER",
        "Asia CCBUTTER ",
        "Asia CCPOWDER",
        "EUR/USD",
        "GBP/USD",
        "AUD/USD",
        "USD/JPY",
        "USD/MYR",
        "USD/IDR",
        "USD/KRW",
        "USD/CNY",
        "NY Futures",
      ],
      currency: [
        "GBP",
        "USD",
        "Ratio",
        "Ratio",
        "EUR",
        "Ratio",
        "Ratio",
        "USD",
        "Ratio",
        "USD",
        "USD",
        "USD",
        "USD",
        "JPY",
        "MYR",
        "IDR",
        "KRW",
        "CNY",
      ],
      intervals: [0, 2, 5, 8, 10, 18, 19],
      footer: true,
    },
    [REGIONS.SA_PG]: {
      symbols: [
        "CA*1",
        "CC*1",
        "2",
        "2",
        "2",
        "5",
        "5",
        "5",
        "7",
        "7",
        "^EURUSD",
        "^GBPUSD",
        "^GBPEUR",
        "^EURJPY",
        "^USDBRL",
        "^USDARS",
        "^USDMXN",
        "^USDCNY",
        "CF340UOP.CS",
      ],
      names: [
        "London Futures",
        "NY Futures",
        "Europe CCBUTTER",
        "Europe CCLIQUOR",
        "Europe CCPOWDER",
        "USA CCBUTTER",
        "USA CCLIQUOR",
        "USA CCPOWDER",
        "Asia CCBUTTER ",
        "Asia CCPOWDER",
        "EUR/USD",
        "GBP/USD",
        "GBP/EUR",
        "EUR/JPY",
        "USD/BRL",
        "USD/ARS",
        "USD/MXN",
        "USD/CNY",
        "NY Futures",
      ],
      currency: [
        "GBP",
        "USD",
        "Ratio",
        "Ratio",
        "EUR",
        "Ratio",
        "Ratio",
        "USD",
        "Ratio",
        "USD",
        "USD",
        "USD",
        "EUR",
        "JPY",
        "BRL",
        "ARS",
        "MXN",
        "CNY",
      ],
      intervals: [0, 2, 5, 8, 10, 18, 19],
      footer: true,
    },
    [REGIONS.SA_ES]: {
      symbols: [
        "CA*1",
        "CC*1",
        "2",
        "2",
        "2",
        "5",
        "5",
        "5",
        "7",
        "7",
        "^EURUSD",
        "^GBPUSD",
        "^GBPEUR",
        "^EURJPY",
        "^USDBRL",
        "^USDARS",
        "^USDMXN",
        "^USDCNY",
        "CF340UOP.CS",
      ],
      names: [
        "London Futures",
        "NY Futures",
        "Europe CCBUTTER",
        "Europe CCLIQUOR",
        "Europe CCPOWDER",
        "USA CCBUTTER",
        "USA CCLIQUOR",
        "USA CCPOWDER",
        "Asia CCBUTTER ",
        "Asia CCPOWDER",
        "EUR/USD",
        "GBP/USD",
        "GBP/EUR",
        "EUR/JPY",
        "USD/BRL",
        "USD/ARS",
        "USD/MXN",
        "USD/CNY",
        "NY Futures",
      ],
      currency: [
        "GBP",
        "USD",
        "Ratio",
        "Ratio",
        "EUR",
        "Ratio",
        "Ratio",
        "USD",
        "Ratio",
        "USD",
        "USD",
        "USD",
        "EUR",
        "JPY",
        "BRL",
        "ARS",
        "MXN",
        "CNY",
      ],
      intervals: [0, 2, 5, 8, 10, 18, 19],
      footer: true,
    },
    [REGIONS.NA]: {
      symbols: ["CC*2", "5", "5", "5", "^USDCAD", "^USDMXN", "CF340UOP.CS"],
      names: ["NY Futures", "USA CCBUTTER", "USA CCLIQUOR", "USA CCPOWDER", "USD/CAD", "USD/MXN", "NY Futures"],
      currency: ["USD", "Ratio", "Ratio", "USD", "CAD", "MXN"],
      intervals: [0, 1, 4, 5, 6, 7],
      footer: true,
    },
  },
  [BUSINESS_UNIT.CORN]: {
    [REGIONS.NA]: {
      symbols: ["ZC*1", "ZC*2", "ZC*3", "ZC*4", "ZL*1", "ZL*2", "ZL*3", "ZL*4", "ZM*1", "ZM*2", "ZM*3", "ZM*4"],
      names: [
        "Corn",
        "Corn",
        "Corn",
        "Corn",
        "Soybean Oil",
        "Soybean Oil",
        "Soybean Oil",
        "Soybean Oil",
        "Soybean Meal",
        "Soybean Meal",
        "Soybean Meal",
        "Soybean Meal",
      ],
      currency: [],
      intervals: [0, 12],
      footer: false,
    },
  },
};

export const prev_sess_line_indexes = {
  [BUSINESS_UNIT.EDIBLE_OILS]: {
    [REGIONS.NA]: [3, 11, 14],
    [REGIONS.EMEA]: [2, 8],
    [REGIONS.SA]: [6],
    [REGIONS.NA_MX_ES]: [8, 11, 14],
  },
  [BUSINESS_UNIT.ANIMAL_FEED]: {
    [REGIONS.EMEA]: [2, 6, 8],
  },
  [BUSINESS_UNIT.GRAINS]: {
    [REGIONS.EMEA]: [4, 14],
  },
  [BUSINESS_UNIT.COCOA]: {
    [REGIONS.EMEA]: [1, 9],
    [REGIONS.SA_PG]: [1, 9],
    [REGIONS.SA_ES]: [1, 9],
    [REGIONS.NA]: [0, 3],
  },
  [BUSINESS_UNIT.CORN]: {
    [REGIONS.NA]: [3, 7, 12],
  },
};

export const COCOA_MARKET_OVERVIEW_ORDER = ["Beans", "Liquor", "Butter", "Powder"];

export { SOURCE, REGIONS, FIELDS };
